/**
 * Coerces the value into a number, or returns a default value.
 */
export function asNumber(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (Number.isNaN(value)) {
    return defaultValue;
  }
  if (typeof value === 'number') {
    return value;
  }
  value = parseFloat(value);
  if (Number.isNaN(value)) {
    return defaultValue;
  }
  return value;
}

/**
 * Rounds a number to the given precision.
 */
export function roundToPrecision(value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return Number(Math.round(value + 'e' + precision) + 'e-' + precision);
}

/**
 * Cuts off the remaining digits.
 *
 * @param {*} value
 * @param {*} precision
 */
export function toPrecision(value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return Number(Math.floor(value + 'e' + precision) + 'e-' + precision);
}

/**
 * Formats a number to locale string.
 *
 * @param {number} value
 * @param {number | undefined} precision
 */
export function numberToLocaleString(value, precision) {
  if (!value) {
    value = 0;
  }
  return value.toLocaleString(navigator.language, typeof precision === 'number' ? {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision
  } : undefined);
}

/**
 * Gets the separators to use for formatting numbers based on locale.
 *
 * @param {*} locale
 */
export function getLocaleNumericSeparators(locale) {
  // Used to extract the separators.
  var PROBE = 1234.5.toLocaleString(locale);
  // The decimal separator is just 1 character before the last character.
  var decimal = PROBE.substr(PROBE.length - 2, 1);
  // The thousands searator is 1 character after the first character.
  var thousand = PROBE.substr(1, 1);
  return {
    thousand: thousand,
    decimal: decimal
  };
}

/**
 * Parses a number from a partial string, using the separators to determine validity.
 *
 * @param {*} str
 * @param {*} separators
 * @returns if valid, returns the `Number`, otherwise `NaN`.
 */
export function parseNumberFromPartialString(str) {
  var separators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getLocaleNumericSeparators();
  var MINUS = '-';
  if (typeof str === 'number') {
    return str;
  }
  if (!str && str !== 0) {
    return Number.NaN;
  }
  var buf = '';
  var lastIndex = str.length - 1;
  var foundDecimal = false;
  var foundMinus = false;
  for (var i = 0; i <= lastIndex; i++) {
    var ch = str[i];
    if (ch === MINUS && !foundMinus) {
      foundMinus = true;
      buf += MINUS;
    } else if (ch === separators.decimal) {
      if (foundDecimal) {
        break;
      }
      foundDecimal = true;
      buf += '.';
    } else if (isDigit(ch)) {
      buf += ch;
    }
  }
  return parseFloat(buf);
}

/**
 * Determines if the character is a digit.
 * @param {*} ch
 */
export function isDigit(ch) {
  var c = ch.charCodeAt(0);
  // 48 = '0'
  // 57 = '9'
  return c >= 48 && c <= 57;
}
//# sourceMappingURL=numberUtil.js.map
